import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AutoCompleteModule } from 'primeng/autocomplete';

import { HisTranslationSelectorComponent } from './component/his-translation-selector.component';
import { HisInputTranslationDirective } from './directive/his-input-translation.directive';
import { HisTranslationPipe } from './pipe/his-translation.pipe';
import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisTranslatedTextComponent } from './component/his-translated-text.component';
import { HisTranslatedHtmlComponent } from './component/his-translated-html.component';

/**
 * SharedModule with very basic components, directives, and pipes to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
@NgModule( {
    imports: [
        // Angular
        CommonModule,
        FormsModule,
        AutoCompleteModule,
        // HIS
        HisCoreSharedModule
    ],

    declarations: [
        // Components
        HisTranslatedTextComponent,
        HisTranslatedHtmlComponent,
        HisTranslationSelectorComponent,

        // Directives
        HisInputTranslationDirective,

        // Pipes
        HisTranslationPipe,

    ],

    exports: [
        // Components
        HisTranslatedTextComponent,
        HisTranslatedHtmlComponent,
        HisTranslationSelectorComponent,

        // Directives
        HisInputTranslationDirective,

        // Pipes
        HisTranslationPipe,
    ]
    // NO PROVIDERS! Providers need to go into HisCoreCoreModule
} )
export class HisTranslationSharedModule { }
